export class LawArticle {
    get id() {
        return this.lawArticleState.id;
    }
    get lawId() {
        return this.lawArticleState.lawId;
    }
    get article() {
        return this.lawArticleState.article;
    }
    get order() {
        return this.lawArticleState.order;
    }
    set lawId(lawId) {
        this.lawArticleState.lawId = lawId;
    }
    set article(article) {
        this.lawArticleState.article = article;
    }
    set order(order) {
        this.lawArticleState.order = order;
    }
    constructor(lawArticleState) {
        this.lawArticleState = lawArticleState;
    }
    getState() {
        return this.lawArticleState;
    }
}
